import { render, staticRenderFns } from "./OrderParticulars.vue?vue&type=template&id=6f9db730&"
import script from "./OrderParticulars.vue?vue&type=script&lang=js&"
export * from "./OrderParticulars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports